import 'izitoast/dist/css/iziToast.min.css';
import iZtoast from 'izitoast';

export class Toaster {
  public static error(msg: string, prefix = 'خطأ') {
    if (msg !== '') {
      return iZtoast.error({
        title: prefix,
        message: msg,
        position: 'bottomLeft',
        rtl: true,
      });
    }
  }
  public static success(msg: string, prefix = '') {
    return iZtoast.success({
      title: prefix,
      message: msg,
      position: 'bottomLeft',
      timeout: 10000,
    });
  }

  public static warning(msg: string, prefix = '') {
    return iZtoast.warning({
      title: prefix,
      message: msg,
      position: 'bottomLeft',
      timeout: 10000,
    });
  }
}
